"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spin = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var Spin = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#fff" : _b;
    var rndId = React.useMemo(function () { return "svg-def-".concat(Math.round(Math.random() * 99999)); }, []);
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: "38", height: "38", viewBox: "0 0 38 38", xmlns: "http://www.w3.org/2000/svg", className: "wellms-component" }, { children: [(0, jsx_runtime_1.jsx)("defs", { children: (0, jsx_runtime_1.jsxs)("linearGradient", __assign({ x1: "8.042%", y1: "0%", x2: "65.682%", y2: "23.865%", id: rndId }, { children: [(0, jsx_runtime_1.jsx)("stop", { stopColor: color, stopOpacity: "0", offset: "0%" }), (0, jsx_runtime_1.jsx)("stop", { stopColor: color, stopOpacity: ".631", offset: "63.146%" }), (0, jsx_runtime_1.jsx)("stop", { stopColor: color, offset: "100%" })] })) }), (0, jsx_runtime_1.jsx)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ transform: "translate(1 1)" }, { children: [(0, jsx_runtime_1.jsx)("path", __assign({ d: "M36 18c0-9.94-8.06-18-18-18", id: "".concat(rndId, "__Oval-2"), stroke: "url(#".concat(rndId, ")"), strokeWidth: "3" }, { children: (0, jsx_runtime_1.jsx)("animateTransform", { attributeName: "transform", type: "rotate", from: "0 18 18", to: "360 18 18", dur: "0.9s", repeatCount: "indefinite" }) })), (0, jsx_runtime_1.jsx)("circle", __assign({ fill: color, cx: "36", cy: "18", r: "1" }, { children: (0, jsx_runtime_1.jsx)("animateTransform", { attributeName: "transform", type: "rotate", from: "0 18 18", to: "360 18 18", dur: "0.9s", repeatCount: "indefinite" }) }))] })) }))] })));
};
exports.Spin = Spin;
exports.default = exports.Spin;
